(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["HP-sec-01"] && !Shopify.designMode) return;
  try {
    
  // TASK 5 (Φ4): lazy-init των autoplay MP4 (data-lazy-video) — src μπαίνει όταν
  // το βίντεο πλησιάζει το viewport· fallback χωρίς IO = άμεση φόρτωση.
  (function () {
    var vids = document.querySelectorAll('video[data-lazy-video]');
    if (!vids.length) return;
    function hydrate(v) {
      v.querySelectorAll('source[data-src]').forEach(function (s) {
        s.src = s.getAttribute('data-src');
        s.removeAttribute('data-src');
      });
      v.load();
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          hydrate(en.target);
          io.unobserve(en.target);
        });
      }, { rootMargin: '800px 0px' });
      vids.forEach(function (v) { io.observe(v); });
    } else {
      vids.forEach(hydrate);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article-maison"]) return;
  try {
    
  // TJAM — Template C: progress + scrollspy + facade + [[σημάδια]] (επέκταση
  // του μηχανισμού Σ08-01β του article.liquid με quote/interlude/faq/module)
  // + default-θέσεις Εγχειριδίου §4 για quote/interlude. Fail-open ολικό.
  (function () {
    var root = document.querySelector('.tjam');
    if (!root) return;
    var body = root.querySelector('[data-article-body]');
    if (!body) return;
    // ── [[σημάδια]] τοποθέτησης (ΙΔΙΑ γραμματική με article.liquid)
    try {
      var mmap = {
        'βιντεο': '.tjam__video', 'video': '.tjam__video', 'youtube': '.tjam__video',
        'social': '.tjam__social', 'κοινωνικα': '.tjam__social', 'post': '.tjam__social',
        'tiktok': '.tjam__social', 'instagram': '.tjam__social',
        'προιοντα': '.tjam__rail', 'products': '.tjam__rail', 'κοσμηματα': '.tjam__rail',
        'συλλογες': '.tjam__relcols', 'collections': '.tjam__relcols',
        'quote': '.tjam__quote', 'αποσπασμα': '.tjam__quote',
        'interlude': '.tjam__inter', 'ιντερμετζο': '.tjam__inter',
        'faq': '.tjam__faq', 'ερωτησεις': '.tjam__faq',
        'module': '.tjam__module', 'εργαλειο': '.tjam__module'
      };
      var mnorm = function (s) {
        s = s.toLowerCase();
        try { s = s.normalize('NFD').replace(/[\u0300-\u036f]/g, ''); } catch (e) { /* παλιό engine */ }
        return s.replace(/\s+/g, '');
      };
      var moved = {};
      body.querySelectorAll('p, div, h2, h3, h6').forEach(function (el) {
        if (!el.parentNode) return;
        var mk = (el.textContent || '').trim().match(/^\[\[(.+)\]\]$/);
        if (!mk) return;
        var msel = mmap[mnorm(mk[1])];
        var mblock = msel && root.querySelector(msel);
        if (mblock) { el.parentNode.replaceChild(mblock, el); moved[msel] = true; }
        else { el.remove(); }
      });
      // ── defaults Εγχειριδίου §4 (μόνο χωρίς σημάδι): quote → μετά το 2ο
      //    κεφάλαιο · interlude → μέση άρθρου. Λοιπά μπλοκ = ήδη στη σωστή
      //    server-side σειρά (βίντεο→προϊόντα→FAQ→social).
      var heads = body.querySelectorAll('h2');
      var q = root.querySelector('.tjam__quote');
      if (q && !moved['.tjam__quote'] && heads.length > 2) {
        var h3rd = heads[2];
        (h3rd.closest('.tj-sec') || h3rd).parentNode.insertBefore(q, h3rd.closest('.tj-sec') || h3rd);
      }
      var inter = root.querySelector('.tjam__inter');
      if (inter && !moved['.tjam__inter'] && heads.length > 3) {
        var hm = heads[Math.ceil(heads.length / 2)];
        if (hm) (hm.closest('.tj-sec') || hm).parentNode.insertBefore(inter, hm.closest('.tj-sec') || hm);
      }
    } catch (e) { /* fail-open: όλα μένουν στη θέση τους */ }
    // ── progress (transform-only)
    var bar = document.querySelector('[data-article-progress]');
    if (bar) {
      var ticking = false;
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var rect = body.getBoundingClientRect();
          var total = rect.height - window.innerHeight;
          var done = Math.min(1, Math.max(0, -rect.top / (total > 0 ? total : 1)));
          bar.style.transform = 'scaleX(' + done + ')';
          ticking = false;
        });
      }, { passive: true });
    }
    // ── Social lazy-hydrate (IG/TikTok — TASK 90 delta): το embed-HTML ζει
    //    αδρανές σε <template>· υδατώνεται ~600px πριν το viewport (τα
    //    platform-scripts ξαναδημιουργούνται — cloned <script> δεν εκτελείται).
    //    Χωρίς IO-υποστήριξη → άμεση υδάτωση. Fail-open: σφάλμα = μένει κρυφό
    //    το slot, το άρθρο ανέγγιχτο.
    try {
      var soc = root.querySelector('[data-tj-social]');
      var tpl = soc && soc.querySelector('[data-tj-social-tpl]');
      if (soc && tpl) {
        var hydrate = function () {
          if (soc.getAttribute('data-tj-social') === 'done') return;
          soc.setAttribute('data-tj-social', 'done');
          var frag = tpl.content.cloneNode(true);
          frag.querySelectorAll('script').forEach(function (s) {
            var ns = document.createElement('script');
            for (var i = 0; i < s.attributes.length; i++) ns.setAttribute(s.attributes[i].name, s.attributes[i].value);
            ns.text = s.text || '';
            s.parentNode.replaceChild(ns, s);
          });
          soc.appendChild(frag);
        };
        if ('IntersectionObserver' in window) {
          var sio = new IntersectionObserver(function (es) {
            es.forEach(function (e) { if (e.isIntersecting) { hydrate(); sio.disconnect(); } });
          }, { rootMargin: '600px 0px' });
          sio.observe(soc);
        } else { hydrate(); }
      }
    } catch (e) { /* fail-open */ }
    // ── YouTube facade → iframe ΜΟΝΟ στο click (TASK 56)
    root.querySelectorAll('[data-article-yt]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-article-yt');
        if (!/^[\w-]{6,20}$/.test(id)) return;
        var f = document.createElement('iframe');
        f.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1';
        f.title = 'Βίντεο YouTube';
        f.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
        f.setAttribute('allowfullscreen', '');
        btn.parentElement.replaceChild(f, btn);
      });
    });
    // ── ids στα h2 χωρίς id (ΙΔΙΑ πρόβλεψη sec-N με το server-side TOC) + spy
    var links = [].slice.call(root.querySelectorAll('[data-art-toc-list] a'));
    var heads2 = [].slice.call(body.querySelectorAll('h2'));
    heads2.forEach(function (h, i) { if (!h.id) h.id = 'sec-' + (i + 1); });
    if (links.length && heads2.length && 'IntersectionObserver' in window) {
      var spy = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          var id = e.target.id;
          links.forEach(function (a) { a.classList.toggle('on', a.getAttribute('href') === '#' + id); });
        });
      }, { rootMargin: '-15% 0px -65% 0px' });
      heads2.forEach(function (h) { spy.observe(h); });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article-story"]) return;
  try {
    
  // TJAS — Atelier Story: progress + dots-scrollspy + carat-visualizer +
  // [[module]] σημάδι-μετακίνηση. Fail-open ολικό (prototype JS αυτούσιο).
  (function () {
    var root = document.querySelector('.tjas');
    if (!root) return;
    var body = root.querySelector('[data-article-body]');
    if (!body) return;
    // [[module]] σημάδι → μετακίνηση του module εκεί· άγνωστα [[...]] έξω
    try {
      var mod = root.querySelector('.tjas__module');
      body.querySelectorAll('p, div, h3, h6').forEach(function (el) {
        if (!el.parentNode) return;
        var mk = (el.textContent || '').trim().match(/^\[\[(.+)\]\]$/);
        if (!mk) return;
        var key = mk[1].toLowerCase().replace(/\s+/g, '');
        if ((key === 'module' || key === 'εργαλειο') && mod) { el.parentNode.replaceChild(mod, el); }
        else { el.remove(); }
      });
    } catch (e) { /* fail-open */ }
    // progress
    var bar = document.querySelector('[data-article-progress]');
    if (bar) {
      var t = false;
      window.addEventListener('scroll', function () {
        if (t) return;
        t = true;
        requestAnimationFrame(function () {
          var r = body.getBoundingClientRect();
          var tot = r.height - window.innerHeight;
          var d = Math.min(1, Math.max(0, -r.top / (tot > 0 ? tot : 1)));
          bar.style.transform = 'scaleX(' + d + ')';
          t = false;
        });
      }, { passive: true });
    }
    // dots scrollspy (prototype: rootMargin -30%/-50%)
    var links = [].slice.call(root.querySelectorAll('[data-art-toc-list] a'));
    var stages = [].slice.call(root.querySelectorAll('.story__stage[id]'));
    if (links.length && stages.length && 'IntersectionObserver' in window) {
      var spy = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          var id = e.target.id;
          links.forEach(function (a) { a.classList.toggle('on', a.getAttribute('href') === '#' + id); });
        });
      }, { rootMargin: '-30% 0px -50% 0px' });
      stages.forEach(function (h) { spy.observe(h); });
    }
    // carat-visualizer: βάρος→διάμετρος (στρογγυλή κοπή, τυπικοί πίνακες)
    var C = [[0.30, 4.3], [0.40, 4.8], [0.50, 5.1], [0.70, 5.7], [0.90, 6.1], [1.00, 6.4], [1.25, 6.9], [1.50, 7.4], [2.00, 8.1]];
    var r = root.querySelector('[data-carat-range]');
    if (r) {
      var st = root.querySelector('[data-carat-stone]');
      var ct = root.querySelector('[data-carat-ct]');
      var mm = root.querySelector('[data-carat-mm]');
      var upd = function () {
        var c = C[+r.value];
        ct.textContent = c[0].toFixed(2) + ' ct';
        mm.textContent = '~ ' + String(c[1]).replace('.', ',') + ' mm διάμετρος';
        st.style.transform = 'scale(' + (c[1] / 6.4) + ')';
      };
      r.addEventListener('input', upd);
      upd();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article"]) return;
  try {
    
  // R5: progress-hairline + TOC scrollspy — inline section-JS (map R5: «ΝΕΟ inline
  // section-JS — μηδέν global»)· rAF-throttled scroll + IO highlight· fail-silent.
  (function () {
    var body = document.querySelector('[data-article-body]');
    if (!body) return;
    // Σ08-01β owner-request: ΣΗΜΑΔΙΑ ΤΟΠΟΘΕΤΗΣΗΣ — παράγραφος που περιέχει ΜΟΝΟ
    // [[σημάδι]] μετακινεί εκεί το αντίστοιχο μπλοκ. Δεκτά (χωρίς διάκριση
    // πεζών/τόνων): [[βίντεο]]/[[video]]/[[youtube]] · [[social]]/[[κοινωνικά]] ·
    // [[προϊόντα]]/[[products]]/[[κοσμήματα]] · [[συλλογές]]/[[collections]].
    // Χωρίς σημάδι = το μπλοκ μένει στο τέλος (ως τώρα)· σημάδι χωρίς αντίστοιχο
    // μπλοκ ή άγνωστο [[...]] = αφαιρείται σιωπηλά (ΠΟΤΕ ορατό σε επισκέπτη).
    // ΠΡΙΝ από το TOC block (έχει δικό του early-return). Fail-open ολικό.
    try {
      var mmap = {
        'βιντεο': '.article-page__video', 'video': '.article-page__video', 'youtube': '.article-page__video',
        'social': '.article-page__social', 'κοινωνικα': '.article-page__social', 'post': '.article-page__social',
        'προιοντα': '.article-page__related', 'products': '.article-page__related', 'κοσμηματα': '.article-page__related',
        'συλλογες': '.article-page__relcols', 'collections': '.article-page__relcols'
      };
      var mnorm = function (s) {
        s = s.toLowerCase();
        try { s = s.normalize('NFD').replace(/[\u0300-\u036f]/g, ''); } catch (e) { /* παλιό engine: μένουν οι τόνοι */ }
        return s.replace(/\s+/g, '');
      };
      body.querySelectorAll('p, div, h2, h3, h6').forEach(function (el) {
        if (!el.parentNode) return; // ήδη αφαιρεμένο (γονιός-wrapper επεξεργάστηκε πρώτος)
        var mk = (el.textContent || '').trim().match(/^\[\[(.+)\]\]$/);
        if (!mk) return;
        var mtarget = mmap[mnorm(mk[1])];
        var mblock = mtarget && document.querySelector(mtarget);
        if (mblock) { el.parentNode.replaceChild(mblock, el); }
        else { el.remove(); }
      });
    } catch (e) { /* fail-open: όλα τα μπλοκ μένουν στη θέση τους */ }
    // progress
    var bar = document.querySelector('[data-article-progress]');
    if (bar) {
      var ticking = false;
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var rect = body.getBoundingClientRect();
          var total = rect.height - window.innerHeight;
          var done = Math.min(1, Math.max(0, -rect.top / (total > 0 ? total : 1)));
          bar.style.transform = 'scaleX(' + done + ')';
          ticking = false;
        });
      }, { passive: true });
    }
    // TASK 56: YouTube facade → iframe μόνο στο click (πριν το TOC early-return)
    document.querySelectorAll('[data-article-yt]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-article-yt');
        if (!/^[\w-]{6,20}$/.test(id)) return;
        var f = document.createElement('iframe');
        f.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1';
        f.title = 'Βίντεο YouTube';
        f.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
        f.setAttribute('allowfullscreen', '');
        btn.parentElement.replaceChild(f, btn);
      });
    });
    // TOC από τα h2 του RTE
    var toc = document.querySelector('[data-article-toc]');
    var list = document.querySelector('[data-article-toc-list]');
    var heads = body.querySelectorAll('h2');
    if (!toc || !list || heads.length < 2) return;
    var links = [];
    heads.forEach(function (h, i) {
      if (!h.id) h.id = 'sec-' + (i + 1);
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      li.appendChild(a);
      list.appendChild(li);
      links.push(a);
    });
    toc.hidden = false;
    if ('IntersectionObserver' in window) {
      var spy = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var id = e.target.id;
          links.forEach(function (a) { a.classList.toggle('is-active', a.getAttribute('href') === '#' + id); });
        });
      }, { rootMargin: '-20% 0px -70% 0px' });
      heads.forEach(function (h) { spy.observe(h); });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    // View toggle (client-only, localStorage — parity με live)
    var grid = document.querySelector('[data-product-grid]');
    var toggles = document.querySelectorAll('[data-view-toggle] button');
    function setView(v) {
      grid.setAttribute('data-cols', v);
      toggles.forEach(function (b) {
        b.classList.toggle('is-active', b.getAttribute('data-view') === v);
      });
    }
    if (grid && toggles.length) {
      var saved = localStorage.getItem('collectionView');
      if (saved) setView(saved);
      toggles.forEach(function (b) {
        b.addEventListener('click', function () {
          setView(b.getAttribute('data-view'));
          localStorage.setItem('collectionView', b.getAttribute('data-view'));
        });
      });
    }

    // Σ07-25στ: το «Δείτε περισσότερα» κελί ΚΑΤΑΡΓΗΘΗΚΕ (owner-κρίση: εμφανιζόταν
    // σε κάθε σελίδα = UX-θόρυβος)· το κλείσιμο των σειρών είναι πλέον ΜΑΘΗΜΑΤΙΚΟ
    // server-side (per-page πολλ. 12 + editorial spans) — μηδέν JS εδώ.

    // Σ07-25β (owner): mobile toolbar reveal-on-scroll-up — scroll κάτω = κρύβεται
    // (οθόνη ελεύθερη), scroll πάνω = εμφανίζεται κάτω από το sticky header
    var tb = document.querySelector('.collection-toolbar');
    var tbSent = document.querySelector('[data-toolbar-sentinel]');
    if (tb && tbSent && window.matchMedia('(max-width: 991px)').matches) {
      var hdrWrap = document.querySelector('.site-header');
      var hdrH = 52;
      function measureHdr() {
        if (hdrWrap && hdrWrap.parentElement) hdrH = hdrWrap.parentElement.offsetHeight || 52;
        tb.style.setProperty('--tj-hdr-h', hdrH + 'px');
      }
      measureHdr();
      window.addEventListener('resize', measureHdr);
      var lastY = window.scrollY;
      var tbTick = false;
      window.addEventListener('scroll', function () {
        if (tbTick) return;
        tbTick = true;
        requestAnimationFrame(function () {
          tbTick = false;
          var y = window.scrollY;
          var pinned = tbSent.getBoundingClientRect().top < hdrH - 2;
          if (!pinned) {
            tb.classList.remove('is-tucked');
            tb.classList.remove('is-float');
          } else {
            tb.classList.add('is-float');
            if (y > lastY + 4) tb.classList.add('is-tucked');
            else if (y < lastY - 4) tb.classList.remove('is-tucked');
          }
          lastY = y;
        });
      }, { passive: true });
    }

    // m2: Off-canvas φίλτρα → ΜΕΤΑΦΕΡΘΗΚΕ στο collection-filters.js (TASK 62στ:
    // single-source — το asset φορτώνει και στο /search όπου το section-JS όχι)

    // Προϊόντα ανά σελίδα → cart attribute (ΙΔΙΟΣ μηχανισμός με live) + reload
    // R1: querySelectorAll — το select ζει σε toolbar (desktop) ΚΑΙ drawer (mobile)
    document.querySelectorAll('[data-per-page]').forEach(function (perPage) {
      perPage.addEventListener('change', function () {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { pagination: perPage.value } })
        }).then(function () { window.location.reload(); });
      });
    });

    // Σ07-25: η USP-γραμμή κυλάει μέσω assets/marquee.js (data-marquee hooks) —
    // το παλιό crossfade αφαιρέθηκε (owner-διόρθωση: «κυλιόμενη σκάλα»)

    // Ταξινόμηση → ?sort_by= (ίδιο param με live)
    var sortBy = document.querySelector('[data-sort-by]');
    if (sortBy) {
      sortBy.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortBy.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }

    // Description read-more
    var more = document.querySelector('[data-desc-more]');
    var less = document.querySelector('[data-desc-less]');
    if (more && less) {
      more.addEventListener('click', function () {
        document.querySelector('[data-desc-teaser]').hidden = true;
        document.querySelector('[data-desc-full]').hidden = false;
      });
      less.addEventListener('click', function () {
        document.querySelector('[data-desc-teaser]').hidden = false;
        document.querySelector('[data-desc-full]').hidden = true;
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customers"]) return;
  try {
    
  (function () {
    var show = document.querySelector('[data-show-recover]');
    var hide = document.querySelector('[data-hide-recover]');
    var panel = document.querySelector('[data-recover]');
    if (show && panel) {
      show.addEventListener('click', function (e) { e.preventDefault(); panel.hidden = false; });
      if (window.location.hash === '#recover') panel.hidden = false; // live deep-link parity
    }
    if (hide && panel) hide.addEventListener('click', function (e) { e.preventDefault(); panel.hidden = true; });
    // προεπιλογή Ελλάδα στο country select
    var country = document.querySelector('select[name="address[country]"]');
    if (country && !country.value) country.value = country.getAttribute('data-default') || 'Greece';
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-3647"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // single-open accordion (live parity)
    var wrap = document.querySelector('[data-faq]');
    if (!wrap) return;
    wrap.addEventListener('toggle', function (e) {
      if (e.target.tagName === 'DETAILS' && e.target.open) {
        wrap.querySelectorAll('details[open]').forEach(function (d) {
          if (d !== e.target) d.open = false;
        });
      }
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["form-page"]) return;
  try {
    
  // TASK 86β/K3 — honeypot guard (delegated, καλύπτει ΚΑΘΕ .brand-form: form-page
  // + globo-form-page native). Fail-open: χωρίς JS η φόρμα δουλεύει κανονικά.
  document.addEventListener('submit', function (e) {
    try {
      var f = e.target;
      if (!f || !f.classList || !f.classList.contains('brand-form')) return;
      var hp = f.querySelector('.bf-hp input, .tjnf-hp input');
      if (hp && hp.value) e.preventDefault();
    } catch (err) { /* fail-open */ }
  }, true);

  // Σ08-01γ — έλεγχος ελληνικού τηλεφώνου (ζεύγος με το inline του tj-native-form
  // — guard __tjTelV: μία εγκατάσταση· εδώ καλύπτει τα w1/s3 του form-page)
  if (!window.__tjTelV) {
    window.__tjTelV = 1;
    (function () {
      function telOk(v) {
        var n = String(v).replace(/[\s\-().]/g, '').replace(/^\+30/, '').replace(/^0030/, '');
        return /^(69\d{8}|2\d{9})$/.test(n);
      }
      document.addEventListener('submit', function (e) {
        var f = e.target;
        if (!f || !f.querySelectorAll) return;
        var tels = f.querySelectorAll('[data-tj-tel]');
        for (var i = 0; i < tels.length; i++) {
          var t = tels[i];
          if (!t.value && !t.required) continue;
          if (!telOk(t.value)) {
            e.preventDefault();
            t.setCustomValidity('Συμπληρώστε έγκυρο ελληνικό τηλέφωνο - 10 ψηφία, π.χ. 69xxxxxxxx ή 2xxxxxxxxx.');
            t.reportValidity();
            return;
          }
          t.setCustomValidity('');
        }
      }, true);
      document.addEventListener('input', function (e) {
        if (e.target && e.target.matches && e.target.matches('[data-tj-tel]')) e.target.setCustomValidity('');
      }, true);
    })();
  }

  // REDESIGN-FINAL Σ07-31 — success-modal ×4 φορμών (tj-form-success snippet):
  // auto-open στο posted flow — showModal() ⇒ κληρονομεί το κεντρικό G16 patch
  // (--vvh/touchmove, Chrome-iOS). Delegated close. Fail-open (noscript fallback).
  try {
    var tjFsm = document.querySelector('[data-tj-fsm]');
    if (tjFsm && typeof tjFsm.showModal === 'function' && !tjFsm.open) tjFsm.showModal();
  } catch (err) { /* fail-open */ }
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('[data-tj-fsm-close]');
    if (!b) return;
    var dg = b.closest('dialog');
    if (dg && typeof dg.close === 'function') dg.close();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    // Mobile menu drawer
    var drawer = document.querySelector('[data-mobile-menu]');
    var openBtn = document.querySelector('[data-mobile-menu-open]');
    if (drawer && openBtn) {
      openBtn.addEventListener('click', function () {
        drawer.showModal();
        openBtn.setAttribute('aria-expanded', 'true');
      });
      drawer.addEventListener('click', function (e) {
        if (e.target === drawer) drawer.close();
      });
      var closeBtn2 = drawer.querySelector('[data-mobile-menu-close]');
      if (closeBtn2) closeBtn2.addEventListener('click', function () { drawer.close(); });
      drawer.addEventListener('close', function () {
        openBtn.setAttribute('aria-expanded', 'false');
      });
    }

    // TASK 21: full-screen search overlay — triggers: desktop μπάρα (focus) +
    // mobile icon (click, href = no-JS fallback). Predictive = κληρονομείται
    // (το overlay έχει δικό του [data-search-box], quickview.js autocomplete).
    var searchOverlay = document.querySelector('[data-search-overlay]');
    if (searchOverlay) {
      var overlayInput = searchOverlay.querySelector('[data-search-overlay-input]');
      var openSearchOverlay = function () {
        if (searchOverlay.open) return;
        searchOverlay.showModal();
        overlayInput.focus();
      };
      // Φ4 owner-ruling: μοναδικός trigger = το 🔍 icon (η inline μπάρα καταργήθηκε
      // — μαζί της έφυγε και το anti-reopen-loop plumbing που υπήρχε μόνο γι' αυτήν·
      // στο icon το focus-restore μετά το close είναι ακίνδυνο)
      var searchIconLink = document.querySelector('.header-actions__search-icon');
      if (searchIconLink) {
        searchIconLink.addEventListener('click', function (e) {
          e.preventDefault();
          openSearchOverlay();
        });
      }
      var overlayClose = searchOverlay.querySelector('[data-search-overlay-close]');
      if (overlayClose) {
        overlayClose.addEventListener('click', function () { searchOverlay.close(); });
      }

      // ---- TASK 21γ: panel δεδομένα (predictive API: collections+queries+products)
      var spBody = searchOverlay.querySelector('[data-sp-body]');
      var spSugg = searchOverlay.querySelector('[data-sp-suggestions]');
      var spSuggHead = searchOverlay.querySelector('[data-sp-sugg-head]');
      var spProds = searchOverlay.querySelector('[data-sp-products]');
      var spNone = searchOverlay.querySelector('[data-sp-none]');
      var spNote = searchOverlay.querySelector('[data-sp-skunote]');
      var spFor = searchOverlay.querySelector('[data-sp-searchfor]');
      var spClear = searchOverlay.querySelector('[data-sp-clear]');
      var spTimer = null;
      var spAbort = null;

      function grNorm(s) {
        // αναζήτηση χωρίς τόνους/πεζά (bold-match των Προτάσεων)
        return s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/ς/g, 'σ');
      }
      function grUpper(s) {
        // ελληνικά κεφαλαία ΧΩΡΙΣ τόνους (τυπογραφικά σωστό — design κανόνας)
        return s.normalize('NFD').replace(/[̀́͂ͅ]/g, '').normalize('NFC').toUpperCase();
      }
      function escHtml(s) { return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }
      function boldMatch(label, raw) {
        var up = grUpper(label);
        var i = grNorm(up).indexOf(grNorm(raw));
        if (i === -1 || !raw) return escHtml(up);
        return escHtml(up.slice(0, i)) + '<b>' + escHtml(up.slice(i, i + raw.length)) + '</b>' + escHtml(up.slice(i + raw.length));
      }
      function spRender(q) {
        clearTimeout(spTimer);
        var raw = q.trim();
        spClear.hidden = raw === '';
        if (raw.length < 2) { spBody.hidden = true; return; }
        spTimer = setTimeout(function () {
          if (spAbort) spAbort.abort();
          spAbort = ('AbortController' in window) ? new AbortController() : null;
          var spForm = document.getElementById('SearchPanelForm');
          // TASK 62: SearchIntel.resolve = raw πρώτα (brands/SKU), αλλιώς
          // Greeklish→ελληνικά variants μέχρι το πρώτο με αποτελέσματα
          var lookup = window.SearchIntel
            ? window.SearchIntel.resolve(raw, spAbort && spAbort.signal)
            : fetch('/search/suggest.json?q=' + encodeURIComponent(raw) +
                '&resources[type]=product,collection,query&resources[limit]=4&resources[options][unavailable_products]=hide',
                spAbort ? { signal: spAbort.signal } : undefined)
                .then(function (r) { return r.json(); })
                .then(function (data) {
                  return { query: raw, results: (data && data.resources && data.resources.results) || {} };
                });
          lookup
            .then(function (out) {
              var res = out.results || {};
              var effective = out.query || raw;
              // το submit θα στείλει το λυμένο ελληνικό query — ΜΟΝΟ αν αντιστοιχεί
              // σε ό,τι είναι ΤΩΡΑ στο πεδίο (guard για γρήγορη πληκτρολόγηση)·
              // αν το query = κατηγορία → effectiveUrl = η συλλογή (owner-αρχή)
              if (spForm) {
                spForm.dataset.effectiveQ = effective;
                spForm.dataset.effectiveFor = raw;
                if (out.collectionUrl) spForm.dataset.effectiveUrl = out.collectionUrl;
                else delete spForm.dataset.effectiveUrl;
              }
              function renderProds(list) {
                spProds.innerHTML = list.map(function (p) {
                  var img = p.featured_image && p.featured_image.url
                    ? '<img src="' + escHtml(p.featured_image.url + (p.featured_image.url.indexOf('?') === -1 ? '?' : '&') + 'width=420') + '" alt="" loading="lazy" width="420" height="420">'
                    : '';
                  return '<a class="sp-card" href="' + escHtml(p.url) + '">' +
                    '<span class="sp-card__media">' + img + '</span>' +
                    '<span class="sp-card__title">' + escHtml(p.title) + '</span>' +
                    '<span class="sp-card__price">€' + escHtml(String(p.price)) + '</span></a>';
                }).join('');
              }

              // TASK 62γ (owner): SKU-mode — ΧΩΡΙΣ fuzzy. Ακριβής κωδικός →
              // ΜΟΝΟ αυτός· ανύπαρκτος → ρητή ένδειξη + παρόμοιοι κωδικοί.
              if (window.SearchIntel && window.SearchIntel.looksLikeSku(raw)) {
                spSuggHead.hidden = true;
                spSugg.innerHTML = '';
                spFor.textContent = 'ΑΝΑΖΗΤΗΣΗ ΓΙΑ ' + raw.toUpperCase();
                window.SearchIntel.verifyExactSku(raw, res.products || []).then(function (exact) {
                  if (exact.length) {
                    spNote.hidden = true;
                    renderProds(exact.slice(0, 3));
                    spNone.hidden = true;
                    spBody.hidden = false;
                  } else {
                    window.SearchIntel.skuSimilar(raw, spAbort && spAbort.signal).then(function (sim) {
                      var simProds = (sim && sim.products) ? sim.products.slice(0, 3) : [];
                      spNote.textContent = simProds.length
                        ? 'Ο κωδικός «' + raw.toUpperCase() + '» δεν υπάρχει — παρόμοιοι κωδικοί:'
                        : 'Ο κωδικός «' + raw.toUpperCase() + '» δεν υπάρχει.';
                      spNote.hidden = false;
                      renderProds(simProds);
                      spNone.hidden = true;
                      spBody.hidden = false;
                    }).catch(function () {});
                  }
                }).catch(function () {});
                return;
              }
              spNote.hidden = true;

              var colls = res.collections || [];
              var queries = res.queries || [];
              var prods = (res.products || []).slice(0, 3);

              // Σ07-12 owner-bug: το predictive προτείνει και ΑΔΕΙΕΣ συλλογές
              // (π.χ. «Βραχιόλια Jcou» με 0 προϊόντα) → φίλτρο με cached σύνολο
              // άδειων handles (sessionStorage, 1 φόρτωση/session, fail-open).
              if (window.__spEmptyColls === undefined) {
                window.__spEmptyColls = null; // loading
                try {
                  var cached = sessionStorage.getItem('sp-empty-colls');
                  if (cached) { window.__spEmptyColls = JSON.parse(cached); }
                } catch (e) { /* fail-open */ }
                if (!window.__spEmptyColls) {
                  (function loadPage(page, acc) {
                    fetch('/collections.json?limit=250&page=' + page)
                      .then(function (r) { return r.json(); })
                      .then(function (j) {
                        var cs = (j && j.collections) || [];
                        cs.forEach(function (c) { if (!(c.products_count > 0)) acc.push(c.handle); });
                        if (cs.length === 250 && page < 5) { loadPage(page + 1, acc); }
                        else {
                          window.__spEmptyColls = acc;
                          try { sessionStorage.setItem('sp-empty-colls', JSON.stringify(acc)); } catch (e) {}
                          /* Σ07-12 option-β (owner): μόλις ετοιμαστεί το φίλτρο, ξανατρέχει
                             η τρέχουσα αναζήτηση → οι άδειες εξαφανίζονται επιτόπου
                             (η 1η προβολή δεν καθυστέρησε ποτέ) */
                          if (acc.length && overlayInput && overlayInput.value.trim()) {
                            overlayInput.dispatchEvent(new Event('input', { bubbles: true }));
                          }
                        }
                      }).catch(function () { window.__spEmptyColls = []; });
                  })(1, []);
                }
              }
              /* + Σ07-12: κρυφές συλλογές (influencer, window.__hiddenCollections) ΕΞΩ */
              var spBlocked = (window.__spEmptyColls || []).concat(window.__hiddenCollections || []);
              if (spBlocked.length) {
                colls = colls.filter(function (c) {
                  var h = ((c.url || '').split('?')[0].split('/collections/')[1] || '').replace(/\/$/, '');
                  try { h = decodeURIComponent(h); } catch (e) {}
                  return spBlocked.indexOf(h) === -1;
                });
              }

              // Προτάσεις: συλλογές πρώτα, μετά query-completions — σύνολο 4
              var items = colls.map(function (c) { return { label: c.title, url: c.url }; });
              queries.forEach(function (que) {
                if (items.length < 4) items.push({ label: que.text, url: '/search?q=' + encodeURIComponent(que.text) + '*&type=product' });
              });
              items = items.slice(0, 4);
              spSugg.innerHTML = items.map(function (it) {
                return '<li><a href="' + escHtml(it.url) + '">' + boldMatch(it.label, effective) + '</a></li>';
              }).join('');
              spSuggHead.hidden = items.length === 0;

              spFor.textContent = 'ΑΝΑΖΗΤΗΣΗ ΓΙΑ ' + grUpper(effective);

              renderProds(prods);
              spNone.hidden = prods.length !== 0;
              spBody.hidden = false;
            })
            .catch(function () { /* aborted ή σφάλμα — κράτα την τρέχουσα κατάσταση */ });
        }, 250);
      }
      overlayInput.addEventListener('input', function () { spRender(overlayInput.value); });
      spClear.addEventListener('click', function () {
        overlayInput.value = '';
        overlayInput.focus();
        spClear.hidden = true;
        spBody.hidden = true;
      });

      // Owner-bug Σ07-10 (γρήγορο Enter): αν το submit φύγει ΠΡΙΝ προλάβει το
      // resolve (debounce 250ms + fetch), θα έστελνε το ωμό greeklish («kolie*»
      // → 11 άσχετα). Interception: κράτα το submit, λύσε, μετά υπέβαλε.
      var spFormEl = document.getElementById('SearchPanelForm');
      if (spFormEl) {
        spFormEl.addEventListener('submit', function (e) {
          var val = overlayInput.value.trim();
          if (!window.SearchIntel || !val) return;
          if (window.SearchIntel.looksLikeSku(val)) return; // SKU: κατευθείαν /search
          if (spFormEl.dataset.effectiveFor === val) {
            // ήδη λυμένο: κατηγορία → συλλογή· αλλιώς το global hook αναλαμβάνει
            if (spFormEl.dataset.effectiveUrl) {
              e.preventDefault();
              location.href = spFormEl.dataset.effectiveUrl;
            }
            return;
          }
          // άλυτο ακόμα (γρήγορο Enter, ελληνικά ή greeklish) → λύσε πρώτα
          e.preventDefault();
          window.SearchIntel.resolve(val).then(function (out) {
            if (out.collectionUrl) { location.href = out.collectionUrl; return; }
            // TASK 62η: ΣΚΕΤΟ query (ακριβές ταίριασμα)· η /search αυτο-αναβαθμίζει
            // σε wildcard μόνο αν τα αποτελέσματα βγουν φτωχά
            location.href = '/search?type=product&q=' + encodeURIComponent(out.query || val);
          }).catch(function () {
            location.href = '/search?type=product&q=' + encodeURIComponent(val);
          });
        });
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-customer-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-hrev]');
    if (!root) return;
    var nodes = root.querySelectorAll('[data-hrev-node]');
    var items = root.querySelectorAll('[data-hrev-item]');
    if (!nodes.length || nodes.length !== items.length) return;
    var idx = 0;
    var timer = null;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function show(i) {
      idx = (i + items.length) % items.length;
      nodes.forEach(function (n, j) { n.classList.toggle('on', j === idx); });
      items.forEach(function (it, j) { it.classList.toggle('on', j === idx); });
    }
    function start() {
      if (reduced || timer) return;
      timer = setInterval(function () { show(idx + 1); }, 7000);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    nodes.forEach(function (n, j) {
      n.addEventListener('click', function () { show(j); stop(); start(); });
    });

    // αυτόματη εναλλαγή ΜΟΝΟ όσο το section είναι ορατό
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { e.isIntersecting ? start() : stop(); });
      }, { threshold: 0.25 }).observe(root);
    } else {
      start();
    }
  })();

  // Ivory Band mobile: dots ↔ σελίδες (1 κριτική/σελίδα)
  (function () {
    var cols = document.querySelector('.hrev4__cols');
    var dots = document.querySelectorAll('[data-hrev4-dot]');
    if (!cols || !dots.length) return;
    cols.addEventListener('scroll', function () {
      var p = Math.round(cols.scrollLeft / cols.clientWidth);
      dots.forEach(function (d, j) { d.classList.toggle('on', j === p); });
    }, { passive: true });
    dots.forEach(function (d, j) {
      d.addEventListener('click', function () {
        cols.scrollTo({ left: j * cols.clientWidth, behavior: 'smooth' });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  (function () {
    var el = document.querySelector('[data-prec]');
    if (!el) return;
    function wireArrows() {
      var row = el.querySelector('[data-prec-row]');
      if (!row) return;
      el.addEventListener('click', function (e) {
        if (e.target.closest('[data-prec-prev]')) row.scrollBy({ left: -row.clientWidth, behavior: 'smooth' });
        if (e.target.closest('[data-prec-next]')) row.scrollBy({ left: row.clientWidth, behavior: 'smooth' });
      });
    }
    if (el.querySelector('.prec__row')) { wireArrows(); return; } // ήδη rendered
    var url = '/recommendations/products?section_id=' + el.getAttribute('data-section-id') +
      '&product_id=' + el.getAttribute('data-product-id') + '&limit=8';
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-prec]');
        if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; wireArrows(); }
      })
      .catch(function () { /* σιωπηλά — προαιρετικό block */ });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  // TASK 64: μετά την υποβολή το return_to φέρνει ?bis=ok (ή customer_posted=true
  // fallback) → δείξε το success ΣΤΟ ΙΔΙΟ σημείο (θέση χαράγματος), κρύψε τα πεδία
  (function () {
    var ok = document.querySelector('[data-bis-ok]');
    if (!ok) return;
    var q = new URLSearchParams(location.search);
    if (q.get('bis') === 'ok' || q.get('customer_posted') === 'true') {
      ok.hidden = false;
      var f = document.querySelector('[data-bis-fields]');
      if (f) f.hidden = true;
    }
  })();

  // R2 STICKY BUY-BAR (mobile, ΕΓΚΕΚΡΙΜΕΝΗ Σ07-14): IO στη buy-zone → is-on όταν
  // βγει από την οθόνη· κουμπί = PROXY-click στο πραγματικό buy-now/ATC (ΙΔΙΟ
  // pipeline + φύλακες — δίδαγμα INCIDENT-01, ΠΟΤΕ δικό του /cart/add)· τιμή =
  // MutationObserver πάνω στο πραγματικό [data-price] (product.js/monopetro.js
  // το ενημερώνουν — η μπάρα δείχνει ΠΑΝΤΑ την αλήθεια). Χωρίς JS: μένει hidden.
  (function () {
    var bar = document.querySelector('[data-tj-buybar]');
    if (!bar || !('IntersectionObserver' in window)) return;
    var root = document.querySelector('[data-product]');
    if (!root) return;
    var zone = root.querySelector('.pdp__atc-row');
    var realBuyNow = root.querySelector('[data-buy-now]');
    var realAtc = root.querySelector('[data-atc-button]');
    var priceSrc = root.querySelector('[data-price]');
    var barPrice = bar.querySelector('[data-tj-buybar-price]');
    var go = bar.querySelector('[data-tj-buybar-go]');
    if (!zone || !go || (!realBuyNow && !realAtc)) return;
    bar.hidden = false;
    // TASK 101 Σ08-04 (owner-εύρημα, πραγματικό iPhone): fixed bottom:0 = πάτος του
    // LAYOUT viewport → στο iOS η μπάρα καθόταν ΜΙΣΗ πίσω από το browser-toolbar
    // (στο Shopify-preview το έκρυβε η preview-μπάρα — γι' αυτό ξέφυγε). Fix: ζωντανή
    // αγκύρωση στο VISUAL viewport (οικογένεια G16/--vvh): bottom = gap layout−visual.
    // Owner-spec: κρυμμένο = 100% έξω · ορατό = 100% ολόκληρο — τίποτα μισό, ποτέ.
    // TASK 101γ (owner-iPhone γύρος-2, photo-proven): το style.bottom ΚΑΤΑΡΓΗΘΗΚΕ —
    // στο iOS rubber-band το vv.offsetTop γίνεται αρνητικό, το gap φούσκωνε και σήκωνε
    // την ΑΓΚΥΡΑ μέχρι τη μέση της οθόνης (η κρυμμένη μπάρα γινόταν ορατή). Τώρα:
    // άγκυρα = bottom:0 ΠΑΝΤΑ· το gap (clamped 0-140, offsetTop ποτέ αρνητικό) πάει
    // σε CSS-var που διαβάζει ΜΟΝΟ το .is-on transform.
    if (window.visualViewport) {
      var vv = window.visualViewport, vvRaf = 0;
      var vvSync = function () {
        vvRaf = 0;
        // TASK 101η (Σ08-07, φωτο-proven live): με ανοιχτό dialog (φόρμα/Νούμερο/
        // διαμάντια/lightbox) ή εστιασμένο πεδίο, το iOS keyboard/scroll-lock αλλάζει
        // το visual viewport → το gap φούσκωνε ως το clamp (140px), η μπάρα ξεπρόβαλλε
        // κάτω από το popup και έμενε «αιωρούμενη» με stale gap μετά το κλείσιμο.
        // Φρένο: πάγωμα υπολογισμού όσο υπάρχει dialog/πληκτρολόγιο· φρεσκάρισμα σε
        // close/focusout (capture) ώστε το stale gap να μη ζει μετά το κλείσιμο.
        if (document.querySelector('dialog[open]')) return;
        var ae = document.activeElement;
        if (ae && /^(INPUT|TEXTAREA|SELECT)$/.test(ae.tagName)) return;
        // TASK 101ζ (τελική αρχιτεκτονική, owner-γύροι δ/ε/στ): gap = ΜΟΝΟ το browser-
        // toolbar (floor 0 — η μπάρα φλατ στον πάτο όταν εκείνο μαζεύεται = 0 κενή
        // γραμμή)· το curve-clearance 13px = ΕΣΩΤΕΡΙΚΟ padding που φθίνει όσο υπάρχει
        // toolbar από κάτω (εκεί δεν χρειάζεται). Screenshots δεν το δείχνουν — γυαλί.
        var gap = Math.max(0, Math.min(140,
          window.innerHeight - vv.height - Math.max(0, vv.offsetTop)));
        bar.style.setProperty('--tj-bb-gap', gap + 'px');
        bar.style.setProperty('--tj-bb-pad', Math.max(0, 13 - gap) + 'px');
      };
      var vvQ = function () { if (!vvRaf) vvRaf = requestAnimationFrame(vvSync); };
      vv.addEventListener('resize', vvQ);
      vv.addEventListener('scroll', vvQ);
      window.addEventListener('scroll', vvQ, { passive: true });
      // TASK 101η: το 'close' του dialog δεν κάνει bubble — capture το πιάνει· ίδιο
      // για focusout (κλείσιμο πληκτρολογίου) → φρέσκος υπολογισμός μετά το πάγωμα.
      document.addEventListener('close', vvQ, true);
      document.addEventListener('focusout', vvQ, true);
      vvSync();
    }
    function target() {
      if (realBuyNow && !realBuyNow.hidden && !realBuyNow.disabled) return realBuyNow;
      return realAtc;
    }
    // TJ-23 Σ07-27: το label γραφόταν ΜΙΑ φορά στο init — soldout variant switch
    // άφηνε «Αγορά Τώρα» που σιωπηλά δεν έκανε τίποτα → refresh() + observers
    // στα πραγματικά κουμπιά (η ετικέτα λέει ΠΑΝΤΑ την αλήθεια, κανόνας ζ΄)
    function refresh() {
      var t = target();
      var soldout = !t || t.disabled;
      if (soldout) {
        go.textContent = (realAtc && realAtc.textContent.trim()) || 'Εξαντλημένο';
      } else {
        go.textContent = (t === realBuyNow) ? 'Αγορά Τώρα' : 'Στο Καλάθι';
      }
      go.disabled = soldout;
    }
    refresh();
    go.addEventListener('click', function () {
      var t = target();
      if (!t || t.disabled) return;
      t.click();
    });
    if ('MutationObserver' in window) {
      if (priceSrc && barPrice) {
        new MutationObserver(function () {
          barPrice.textContent = priceSrc.textContent.trim();
          refresh();
        }).observe(priceSrc, { childList: true, characterData: true, subtree: true });
      }
      if (realAtc) {
        new MutationObserver(refresh).observe(realAtc, { attributes: true, childList: true, characterData: true, subtree: true });
      }
      if (realBuyNow) {
        new MutationObserver(refresh).observe(realBuyNow, { attributes: true });
      }
    }
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      // ορατή ΜΟΝΟ όταν η buy-zone είναι ΠΑΝΩ από το viewport (πέρασε το scroll)
      var below = e.boundingClientRect.top < 0;
      bar.classList.toggle('is-on', !e.isIntersecting && below);
    }, { threshold: 0 }).observe(zone);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"]) return;
  try {
    
  (function () {
    var el = document.querySelector('[data-rv]');
    if (!el) return;
    var KEY = 'recently-viewed';
    var current = el.getAttribute('data-current-handle');

    function read() {
      try { var a = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(a) ? a : []; }
      catch (e) { return []; }
    }
    var list = read();
    // TASK 62β: κρυφά βοηθητικά προϊόντα (εγγύηση) — ούτε render ούτε καταγραφή
    var excluded = window.__searchExcluded || [];
    list = list.filter(function (h) { return excluded.indexOf(h) === -1; });

    // render όσα ΔΕΝ είναι το τρέχον
    var show = list.filter(function (h) { return h !== current; }).slice(0, 8);
    if (show.length) {
      el.hidden = false;
      var row = el.querySelector('[data-rv-row]');
      show.forEach(function (handle) {
        var item = document.createElement('div');
        item.className = 'rv__item';
        item.hidden = true;
        row.appendChild(item);
        fetch('/products/' + handle + '.js')
          .then(function (r) { if (!r.ok) throw new Error('gone'); return r.json(); })
          .then(function (prod) {
            var img = prod.featured_image ? prod.featured_image + (prod.featured_image.indexOf('?') === -1 ? '?' : '&') + 'width=400' : '';
            var n = (prod.price / 100).toFixed(2).split('.');
            var money = '€' + n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + n[1];
            // TJ-16β Σ07-27: +width/height (τετράγωνο 400 CDN crop-λογική εικόνας
            // προϊόντος = intrinsic ratio γνωστό) → μηδέν micro-CLS στο inject
            item.innerHTML = '<a href="' + prod.url + '">' + (img ? '<img loading="lazy" src="' + img + '" alt="" width="400" height="400">' : '') + '</a>' +
              '<a class="rv__item-title" href="' + prod.url + '">' + prod.title + '</a>' +
              '<div class="rv__item-price">' + money + '</div>';
            item.hidden = false;
          })
          .catch(function () { item.remove(); });
      });
    }

    // καταχώρησε το τρέχον (μετά το render — να μη δείχνει τον εαυτό του)·
    // TASK 62β: τα κρυφά βοηθητικά (εγγύηση) δεν καταγράφονται ποτέ
    if (excluded.indexOf(current) === -1) {
      var next = [current].concat(list.filter(function (h) { return h !== current; })).slice(0, 10);
      try { localStorage.setItem(KEY, JSON.stringify(next)); } catch (e) { /* private mode */ }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tj-category-row"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Delegation: πολλαπλά instances + ζωντανή προσθήκη στο Customize. Fail-open.
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-tjcatr-arrow]');
      if (!btn) return;
      var host = btn.closest('[data-tjcatr]');
      var row = host && host.querySelector('[data-tjcatr-row]');
      if (!row) return;
      var dir = btn.getAttribute('data-tjcatr-arrow') === 'next' ? 1 : -1;
      row.scrollBy({ left: dir * row.clientWidth * 0.85, behavior: 'smooth' });
    });
    function sync() {
      document.querySelectorAll('[data-tjcatr]').forEach(function (host) {
        var row = host.querySelector('[data-tjcatr-row]');
        if (!row) return;
        if (row.scrollWidth <= row.clientWidth + 4) host.setAttribute('data-tj-fits', '');
        else host.removeAttribute('data-tj-fits');
      });
    }
    window.addEventListener('load', sync);
    window.addEventListener('resize', sync);
    document.addEventListener('shopify:section:load', sync);
    sync();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tj-icons-band"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Delegation: δουλεύει για πολλαπλά instances + sections που προστίθενται
    // ζωντανά στο Customize. Fail-open παντού.
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-tjicb-arrow]');
      if (!btn) return;
      var host = btn.closest('[data-tjicb]');
      var row = host && host.querySelector('[data-tjicb-row]');
      if (!row) return;
      var dir = btn.getAttribute('data-tjicb-arrow') === 'next' ? 1 : -1;
      row.scrollBy({ left: dir * row.clientWidth * 0.85, behavior: 'smooth' });
    });
    function sync() {
      document.querySelectorAll('[data-tjicb]').forEach(function (host) {
        var row = host.querySelector('[data-tjicb-row]');
        if (!row) return;
        if (row.scrollWidth <= row.clientWidth + 4) host.setAttribute('data-tj-fits', '');
        else host.removeAttribute('data-tj-fits');
      });
    }
    window.addEventListener('load', sync);
    window.addEventListener('resize', sync);
    document.addEventListener('shopify:section:load', sync);
    sync();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist-page"]) return;
  try {
    
  (function () {
    var body = document.querySelector('[data-wishlist-body]');
    if (!body) return;
    var table = document.querySelector('[data-wishlist-table]');

    function money(cents) {
      var n = (cents / 100).toFixed(2).split('.');
      return '€' + n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + n[1];
    }

    function render() {
      var items = (window.ThemeWishlist && window.ThemeWishlist.read()) || [];
      var empty = document.querySelector('[data-wishlist-empty]');
      var share = document.querySelector('[data-wishlist-share]');
      body.innerHTML = '';
      if (!items.length) {
        table.hidden = true;
        empty.hidden = false;
        share.hidden = true;
        return;
      }
      table.hidden = false;
      empty.hidden = true;
      share.hidden = false;
      var mailto = document.querySelector('[data-wishlist-mailto]');
      if (mailto) {
        var urls = items.map(function (h) { return location.origin + '/products/' + h; }).join('%0D%0A');
        mailto.href = 'mailto:?subject=' + encodeURIComponent('Η wishlist μου — ' + location.hostname) + '&body=' + urls;
      }
      // placeholder rows με τη σειρά του χρήστη — γεμίζουν όταν έρθει το καθένα
      items.forEach(function (handle) {
        var tr = document.createElement('tr');
        tr.hidden = true;
        body.appendChild(tr);
        fetch('/products/' + handle + '.js')
          .then(function (r) { if (!r.ok) throw new Error('gone'); return r.json(); })
          .then(function (prod) {
            var img = '';
            if (prod.featured_image) {
              img = prod.featured_image + (prod.featured_image.indexOf('?') === -1 ? '?' : '&') + 'width=170';
            }
            tr.innerHTML =
              '<td><a href="' + prod.url + '">' + (img ? '<img loading="lazy" src="' + img + '" alt="">' : '') + '</a></td>' +
              '<td><a class="wishlist-table__title-link" href="' + prod.url + '">' + prod.title + '</a></td>' +
              '<td class="wishlist-table__price">' + money(prod.price) + '</td>' +
              '<td class="wishlist-table__add"><a class="wishlist-table__select" href="' + prod.url + '">Επιλέξτε</a></td>' +
              '<td class="wishlist-table__remove-td"><button type="button" class="wishlist-table__remove" aria-label="Αφαίρεση" data-wl-remove="' + handle + '">✕</button></td>';
            tr.hidden = false;
          })
          .catch(function () { tr.remove(); /* προϊόν αφαιρέθηκε από τον κατάλογο */ });
      });
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-wl-remove]');
      if (!btn) return;
      window.ThemeWishlist.toggle(btn.getAttribute('data-wl-remove'));
      render();
    });

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', render);
    else render();
  })();

  } catch(e) { console.error(e); }
})();
})();
